up.compiler(".up_remove_workshopper", function (element) {
  const fresk_slug = element.dataset.freskslug;
  const workshop_slug = element.dataset.workshopslug;
  const animator_slug = element.dataset.animatorslug;
  function onClick() {
    up.render({
      url: `/manage-workshops/remove-workshopper/${fresk_slug}/${workshop_slug}/${animator_slug}`,
      method: "delete",
      target: "#workshoppers, .js-wshop-img.is-active, .js-wshop-pro.is-active",
    });
  }
  element.addEventListener("click", onClick);
  return () => {
    element.removeEventListener("click", onClick);
  };
});
